import { useEffect, useRef, useState } from "react";

const ITEMS = [
  "Scoped like a mission",
  "Mapped like terrain",
  "One build a month",
  "You own everything",
  "No page-builder lock-in",
  "Delivered without surprises",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(true);

  // stop paying for this every frame once it's scrolled out of view
  useEffect(() => {
    const el = sectionRef.current;
    if (!el || !("IntersectionObserver" in window)) return;
    const io = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { rootMargin: "200px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative z-10 overflow-hidden border-y border-hairline bg-panel/50 py-6"
      data-testid="marquee"
      aria-hidden="true"
    >
      <div
        className="flex w-max animate-[marquee_38s_linear_infinite] items-center gap-10 whitespace-nowrap will-change-transform"
        style={{ animationPlayState: inView ? "running" : "paused" }}
      >
        {row.map((t, i) => (
          <div key={i} className="flex items-center gap-10">
            <span className="font-serif text-3xl italic text-ink md:text-4xl">
              {t}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-rust" />
          </div>
        ))}
      </div>
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .animate-\\[marquee_38s_linear_infinite\\] { animation: none !important; }
        }
      `}</style>
    </section>
  );
}
